import ResourceType from '@v/inventory/resources/edit/ResourceType.js'

export default class UpsertResourceModel {
  constructor(rawModel, businessUnitKey) {
    this.Key = rawModel?.Key || null
    this.ResourceType = rawModel?.ResourceType || ResourceType.Normal
    this.BusinessUnitKey = rawModel?.BusinessUnitKey || businessUnitKey
    this.Description = rawModel?.Description || null
    this.Slug = rawModel?.Slug || null
    this.Capacity = rawModel?.Capacity || null
    this.TimeslotMinutes = rawModel?.TimeslotMinutes || null
    this.Icon = rawModel?.Icon || null
    this.UseAsFilter = rawModel?.UseAsFilter || false
    this.IsActive = typeof rawModel?.IsActive === 'boolean' ? rawModel.IsActive : true
    this.ShowOnScheduler =
      typeof rawModel?.ShowOnScheduler === 'boolean' ? rawModel.ShowOnScheduler : true
    this.AllowOrderChanges =
      typeof rawModel?.AllowOrderChanges === 'boolean' ? rawModel.AllowOrderChanges : true
    this.Exclusive = rawModel?.Exclusive || false
    this.LeadInTime = rawModel?.LeadInTime || null
    this.LeadOutTime = rawModel?.LeadOutTime || null
    this.IgnoreTimeslotDuration = rawModel?.IgnoreTimeslotDuration || false
    this.DefaultProductKey = rawModel?.DefaultProductKey || null
    this.TeamSize = rawModel?.TeamSize || 0
    this.ExternalType = rawModel?.ExternalType || null // [ NotSet, CardConnect, Clubspeed, ERP, PublicApi, Gifty, Stripe, StripeTest, Till, Voucherify, Zapier, Zendesk, Innomeer, ExternalPaymentMethod, Briq, Lightspeed, Fast, Entertainment501 ]
    this.ExternalID = rawModel?.ExternalID || null
    this.Priority = rawModel?.Priority || 0
    this.ResetTime = rawModel?.ResetTime || null
    this.OneTimeLeadIn = rawModel?.OneTimeLeadIn || null
    this.PermanentTimeLeadIn = rawModel?.PermanentTimeLeadIn || null
    this.ExternalResources = rawModel?.ExternalResources || [] // see explanation below *
    this.OfflineProductKey = rawModel?.OfflineProductKey || null
    this.Color = rawModel?.Color || null
    this.Abbreviation = rawModel?.Abbreviation || null
    this.ParentResourceKey = rawModel?.ParentResourceKey || null
    this.TranslationInfo = rawModel?.TranslationInfo || null
    this.ResetTimeType = rawModel?.ResetTimeType || 'NotUsed'
    this.ChildResources = rawModel?.ChildResources?.map(x => new ChildResource(x))
  }

  // * ExternalResources
  // For resources from feed: ExternalResources is always filled with a single string value (the id of that external resource)
  // For the Briq resources, ExternalResources can be arbitrary size - we could in theory link to multiple external resources

  hasAvailableCultures() {
    return !!this.TranslationInfo?.hasAvailableCultures?.length
  }

  isResourceGroup() {
    return this.ResourceType === ResourceType.ResourceGroup
  }

  isSubResource() {
    return this.ResourceType === ResourceType.SubResource
  }
}

class ChildResource {
  constructor(rawModel) {
    this.Key = rawModel.Key
    this.Name = rawModel.Name
    this.ShowOnScheduler = rawModel.ShowOnScheduler
    this.Priority = rawModel.Priority
    this.Abbreviation = rawModel.Abbreviation
    this.Color = rawModel.Color
    this.Icon = rawModel.Icon
  }
}
